import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import PageOperate from './PageOperate';
import { disabledConfig } from '../utils/index';

var NormalPagination = function NormalPagination(_ref) {
  var border = _ref.border,
      operateDisabled = _ref.operateDisabled,
      pageList = _ref.pageList,
      onCurrentPage = _ref.onCurrentPage;
  return /*#__PURE__*/React.createElement("ul", {
    className: classNames('jmtd-pagination-list', {
      'jmtd-pagination-item-border': border,
      'jmtd-pagination-item-outline': !border
    })
  }, pageList.map(function (_ref2) {
    var type = _ref2.type,
        show = _ref2.show,
        selected = _ref2.selected;
    return ['number', 'prev', 'next'].includes(type) ? /*#__PURE__*/React.createElement("li", {
      "data-event-name": "paginate",
      "data-event-content": type === 'number' ? 'true' : type === 'prev' ? '前' : '后',
      key: type + show,
      className: classNames('jmtd-pagination-item', "jmtd-pagination-item-".concat(type), {
        'jmtd-pagination-item-disabled': disabledConfig(operateDisabled)[type],
        'jmtd-pagination-item-select': selected
      }),
      onClick: function onClick() {
        return !disabledConfig(operateDisabled)[type] && onCurrentPage(show, type);
      }
    }, show) : /*#__PURE__*/React.createElement(PageOperate, {
      key: type + show,
      className: "jmtd-pagination-item-".concat(type),
      type: type,
      disabled: disabledConfig(operateDisabled)[type],
      onClick: function onClick() {
        return onCurrentPage(show, type);
      }
    }, show);
  }));
};

NormalPagination.propTypes = {
  border: PropTypes.bool,
  operateDisabled: PropTypes.object.isRequired,
  pageList: PropTypes.array.isRequired,
  onCurrentPage: PropTypes.func.isRequired
};
NormalPagination.defaultProps = {
  border: true
};
export default NormalPagination;